<template>
  <div class="card card-custom card-stretch gutter-b">
    <div class="card-header border-0">
      <h3 class="card-title text-dark">مقصد‌ها</h3>
      <div class="card-toolbar">
        <router-link
          :to="{ name: 'destinations-index' }"
          class="btn btn-sm btn-primary"
        >
          بیشتر
        </router-link>
      </div>
    </div>
    <div class="card-body pt-1 pb-4">
      <div v-if="destinations.length">
        <template v-for="(destination, i) in destinations">
          <div
            v-if="i < 5"
            class="d-flex align-items-center mb-2"
            v-bind:key="i"
          >
            <router-link
              :to="{
                name: 'destinations-show',
                params: { id: destination.id }
              }"
              class="d-block w-100 border-bottom pb-2"
            >
              <div class="w-auto btn-clean d-flex px-1">
                <span class="symbol symbol-25 symbol-light-success">
                  <img
                    :alt="destination.name"
                    :src="
                      `/media/destinations/${
                        destinationTypes[destination.type]
                      }.png`
                    "
                  />
                </span>
                <span class="ml-2 font-size-lg pt-1 text-left">
                  {{ destination.name }}
                </span>
              </div>
            </router-link>
          </div>
        </template>
      </div>
      <div v-else>مقصدی یافت نشد.</div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "destinations-list",
  props: {
    destinations: Array
  },
  computed: {
    ...mapGetters(["destinationTypes"])
  }
};
</script>
